import React from 'react';
import ClinicianLocator from '.';
import { GUEST_PATH } from '../../../../constants';

const Routes = {
     path: GUEST_PATH.CLINICIAN_LOCATOR,
     breadcrumb: 'Clinician Locator',
     element: <ClinicianLocator />,
};

export default Routes;
